<template>
    <a-spin :spinning="AuthLayoutSpinning" size="large">
        <div class="main-content bg-default">
            <!-- Navbar -->
            <base-nav class="navbar-top navbar-horizontal navbar-dark"
                    containerClasses="px-4 container"
                    expand>
                <router-link slot="brand" class="navbar-brand" to="/">
                    <img src='@/assets/barter-full.png' alt='logobarter'>
                </router-link>
            </base-nav>
            <!-- Header -->
            <div class="header bg-gradient-success py-7 py-lg-8">
                <div class="container">
                    <div class="header-body text-center mb-7">
                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-6">
                                <h1 class="text-white">Welcome to BXI {{ environment }}!</h1>
                                <p class="text-lead text-white">
                                    This is a powerful retail solution for your business.
                                </p>
                                <span class="text-lead text-danger">{{ environment }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="separator separator-bottom separator-skew zindex-100">
                    <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1">
                        <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                    </svg>
                </div>
            </div>
            <!-- Page content -->
            <div class="container mt--8 pb-5">
                <slide-y-up-transition mode="out-in" origin="center top">
                    <router-view @changeAuthLayoutSpinning="changeAuthLayoutSpinning"></router-view>
                </slide-y-up-transition>
            </div>
            <footer class="py-5">
                <div class="container">
                    <div class="row align-items-center justify-content-xl-between">
                        <div class="col-xl-6">
                            <div class="copyright text-center text-xl-left text-muted">
                                &copy; {{year}} <a href="https://www.iripple.com" class="font-weight-bold ml-1"
                                                target="_blank">iRipple, Inc.</a>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="copyright text-center text-xl-right text-muted">
                                <a href="https://status.bartermms.com/" class="font-weight-bold ml-1" target="_blank">Status Page</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </a-spin>
</template>

<script>
  import { SlideYUpTransition } from 'vue2-transitions'
  import { mapState, mapActions } from 'vuex'

  export default {
    computed: {
        ...mapState(['endPoint']),
    },
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    mounted: async function () {
        const envMapping = {
            'hq.bxi.world': 'STAGING ENVIRONMENT',
            'hotfix': 'HOTFIX ENVIRONMENT',
            'local': 'LOCAL ENVIRONMENT'
        };
        
        const envKey = Object.keys(envMapping).find(key => this.endPoint.toLowerCase().includes(key));
        if (envKey) {
            this.environment = envMapping[envKey];
        }
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        AuthLayoutSpinning:false,
        environment: '',
      }
    },
    methods: {
        changeAuthLayoutSpinning (status) {
            this.AuthLayoutSpinning = status;
        }
    }
  }
</script>
<style>
</style>
